export default __webpack_public_path__ + "static/media/Snd1.33ad5773.mp3";